package com.essntl.features.invoice.data.supabase

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [InvoiceSupabaseDataSource::class])
internal class InvoiceSupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<InvoiceDto> {
    override val tableName: String = "invoice"
}
